import * as classnames from 'classnames'
import * as React from 'react'

export interface IRequestType {
  state: boolean
  title: string
  action: (state: any) => void
  handleSetValue: (key: string, value: string) => void
}

const RequestType = (props: any) => {
  const handleSelect = () => {
    props.handleSetValue('eligibilityService', props.title)
    props.action()
  }
  return (
    <div className='flex items-center' onClick={handleSelect}>
      <div
        className={classnames('membership-radio', {
          'membership-radio--active': props.state
        })}
      >
        <div
          className={classnames('membership-radio-slider', {
            'membership-radio-slider--active': props.state
          })}
        />
      </div>
      <span className='h5 font-dark-grey ml1'>{props.title}</span>
    </div>
  )
}

export default RequestType



// WEBPACK FOOTER //
// ./src/components/membership-request/RequestType.tsx